import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserProfile from "../../../lms-shared/UI/UserProfile";
import defaultAvatar from '../../../../assests/user-profile/default-avatar.png'
import classes from './Post.module.css'
import IdeRunner from "../../../lms-shared/IdeRunnerWarrper/IdeRunner";
import PostPopUp from "./Share/PostPopUp";
import DeleteSharePostPopup from "./Share/DeleteSharePostPopup";
import { ObjectTypeEnum } from "../../../../models/ObjectTypeEnum";
import ShowCodeBtn from "./ShowCodeBtn";
import { PermmisionPostsTypeEnum } from '../../../../models/PermmisionPostsTypeEnum';
import useShareTypes from "../../../../hooks/useShareTypes";
import { TargetObjectIdEnum } from "../../../../models/TargetObjectIdEnum";
import { onKeyDown } from "../../../../service";
import { ActionsPopup, Action } from "../../../UI/ActionsPopup";
import { postsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ConfirmShareProjectPopup from "./Share/ConfirmShareProjectPopup";
import { FeedbackTypeTextEnum } from "../../../../models/FeedbackTypeEnum";

const Post = ({ p, getDateAgo, changePosts, handeleSaveEditChanges, setCurrentPostPlay, play, currentPostPlay, friendsData }) => {
    const texts = useSelector((state) => state.translate.texts);
    const { user } = useSelector(state => state.auth);
    const [message, setMessage] = useState(null);
    const selectedList = useShareTypes()
    const dispatch = useDispatch();

    const playPost = (postData) => {
        let ide = postData.contentData
        if (ide) {
            let project = {
                ideId: ide.Ide.Id,
                ideUrl: ide.Ide.Url,
                ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                ideLang: ide.Ide.Lang ? ide.Ide.Lang : "he",
                fileUrl: postData.url,
                share: true
            }
            setCurrentPostPlay({ id: postData.id, projectData: project });
        }
    }

    const editPost = (p) => {
        setMessage(<PostPopUp friendsData={friendsData} close={() => setMessage(false)} post={p} beenSharedBefore={true} setBeenSharedBefore={() => console.log("shared")} changePosts={handeleSaveEditChanges} />)
    }

    const deletePost = (p) => {
        setMessage(<DeleteSharePostPopup dataPost={p} changePosts={() => changePosts(p.id)} setShowPopup={setMessage} close={() => setMessage(false)} beenSharedBefore={true} setBeenSharedBefore={() => console.log("shared")} />)
    }

    const renderTargetObjectTypeName = (p) => {
        const type = ObjectTypeEnum[p?.shares?.[0].targetObjectType];
        switch (type) {
            case ObjectTypeEnum.User:
                const friendNames = p.shares.map(f => (f.name || `${f.targetObjectFirstName} ${f.targetObjectLastName?.[0]}.`));
                return (<>{friendNames.join(', ')}.</>)
            case ObjectTypeEnum.ConstUserGroup:
                if (p?.shares?.[0].targetObjectId == TargetObjectIdEnum.ConstUserGroup) {
                    return (<>{selectedList()[ObjectTypeEnum.ConstUserGroup]}</>)
                }
                return (<>{selectedList()[ObjectTypeEnum.External]}</>)
            default:
                return (<>{selectedList()[type]}</>)
        }
    }

    const reportOffensivePost = (p) => {
        const postFeedbackAddInput = {
            postId: p.id,
            userId: user.id,
            feedbackType: FeedbackTypeTextEnum.offensive,
            content: ""
        }
        postsApi.postsFeedbackAddPost({ postFeedbackAddInput: postFeedbackAddInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.errorOccuredTryAgainLater, error: error, statusCode: response?.statusCode, message: error.message, level: 2, component: "Post", line: 60 }))
            }
            else {
                setMessage(<ConfirmShareProjectPopup close={() => setMessage(false)} text={texts.requestForwardedForProcessing} type={"successRemovePost"} />)
            }
        })
    }

    return (
        <div className={classes.PostWarrper}>
            <div className={classes.UserWithDots}>
                {p?.user &&
                    <div className={classes.UserWarrper}>
                        <UserProfile width="47px" image={p.user.profileImage ? `${p.user.profileImage}` : defaultAvatar} />
                        <div className={classes.User}>
                            <div className={classes.UsesDetails}>
                                <div> {p.user.firstName} {p.user.lastName?.[0]}. </div>
                                <div className={classes.SchoolName}>&nbsp;{p?.contentData?.School?.Name}</div>
                            </div>
                            <div className={classes.Date}> {getDateAgo(p)} <span> | {renderTargetObjectTypeName(p)}</span></div>
                        </div>
                    </div>}
                <ActionsPopup>
                    {p?.user?.id === user.id && <Action onClick={() => editPost(p)}>{texts.editPostText}</Action>}
                    {user.isStudent && p?.user?.id !== user.id && <Action onClick={() => reportOffensivePost(p)}>{texts.offensivePost}</Action>}
                    {(!user.isStudent || p?.user?.id === user.id) && <Action onClick={() => deletePost(p)}>{texts.deletePostText}</Action>}
                </ActionsPopup>
            </div>

            <div className={classes.PostName}>{p?.name}</div>

            <div className={classes.CurrentPostwarrper}>
                {play ?
                    <div className={`${p?.contentData && p?.contentData.Ide.Id === 1 ? classes.CurrentMKPost : classes.CurrentPost}`}>
                        <IdeRunner projectData={currentPostPlay.projectData}></IdeRunner>
                    </div> :
                    <div className={classes.StartImage} style={{ backgroundImage: `url(${p?.thumbnail})` }}>
                        <div className={classes.Play} onClick={() => playPost(p)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => playPost(p))}></div>
                    </div>}
            </div>
            {p.shares && ((ObjectTypeEnum[p.shares[0].targetObjectType] !== ObjectTypeEnum.User && PermmisionPostsTypeEnum[p.shares[0].permissionMask] == PermmisionPostsTypeEnum.RunnerAndCode) || (ObjectTypeEnum[p.shares[0].targetObjectType] === ObjectTypeEnum.User && PermmisionPostsTypeEnum[p.shares?.find(s => s.targetObjectId === user.id)?.permissionMask] === PermmisionPostsTypeEnum.RunnerAndCode)) && <ShowCodeBtn ideId={p.contentData.Ide?.Id} postId={p.id}></ShowCodeBtn>}
            {message}
        </div>
    )
}

export default Post;